<button [ngStyle]="styles" class="outlinedGreenButton" [style.border-color]="borderColor" [style.border-radius]="radius"
    [style.width]="width" [style.height]="height" (click)="onClick()">
    <ng-content select=".before"></ng-content>
    {{ label }}
    <ng-content select=".after"></ng-content>
</button>